import "./Error.css";
import "../styles/main.css"; // Optional for custom styling

function Hero() {
  return (
    <div class="error-page">
    <div class="error-card">
    <h1>404</h1>
    <h2>Oops! Page Not Found</h2>
    <p class="mb-4">The page you are looking for does not exist or has been moved. Please check the URL or return to the home page.</p>
    <a href="/" class="btn btn-dark back-home-btn">&larr; Back to Home</a>
  </div>
  </div>
  );
}

export default Hero;